import React from "react"
import styled from "@emotion/styled"
import urlBuilder from "@sanity/image-url"

function PageHeader({ backgroundImage, overlay, title, children }) {
  const urlFor = (source) =>
    urlBuilder({
      projectId: "yk6mnr40",
      dataset: "production",
    }).image(source)

  const PageHeader = styled.div`
    position: relative;
    /* display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center; */
    padding: var(--size-11);
    background-color: rgba(0, 0, 0, 0.8);
    background-image: ${(props) =>
      backgroundImage &&
      `url(
        ${urlFor(backgroundImage.asset.id)
          .auto("format")
          .width(800)
          .height(320)
          .fit("crop")
          .focalPoint(
            backgroundImage.hotspot == null ? 0.5 : backgroundImage.hotspot.x,
            backgroundImage.hotspot == null ? 0.5 : backgroundImage.hotspot.y
          )
          .url()})
          `};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
    max-height: 200px;
    margin-bottom: var(--size-8);

    @media (min-width: 900px) {
      background-image: ${(props) =>
        backgroundImage &&
        `url(
        ${urlFor(backgroundImage.asset.id)
          .auto("format")
          .width(1680)
          .height(320)
          .fit("crop")
          .focalPoint(
            backgroundImage.hotspot == null ? 0.5 : backgroundImage.hotspot.x,
            backgroundImage.hotspot == null ? 0.5 : backgroundImage.hotspot.y
          )
          .url()})
          `};
      margin-bottom: var(--size-10);
    }
  `

  const Overlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0%;
    left: 0%;
    background: rgba(40, 35, 20, 0.6);
    mix-blend-mode: multiply;
  `

  const PageTitle = styled.span`
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    > * {
      margin-bottom: 0;
      color: var(--colour-white);
    }
  `

  const checkOverlay = (backgroundImage, overlay, title) => {
    if (backgroundImage && overlay) {
      return <Overlay />
    }
  }

  return (
    <PageHeader>
      {checkOverlay(backgroundImage, overlay)}
      <PageTitle>
        <h1>{title ? title : children}</h1>
      </PageTitle>
    </PageHeader>
  )
}

export default PageHeader
